// Constants to avoid magic numbers
const BYTES_PER_KILOBYTE = 1024;
const BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * BYTES_PER_KILOBYTE;
const MAX_ATTACHMENT_SIZE_MB = 10;
const DEFAULT_COMMENTS_PER_PAGE = 50;
const MAX_COMMENT_LENGTH = 1024;

export interface CommentConfiguration {
  readonly apiBaseUrl: string;
  readonly maxCommentLength: number;
  readonly maxAttachmentSize: number;
  readonly allowedAttachmentTypes: readonly string[];
  readonly enableViewpoints: boolean;
  readonly enableAttachments: boolean;
  readonly commentsPerPage: number;
}

export const DEFAULT_COMMENT_CONFIG: CommentConfiguration = {
  apiBaseUrl: `https://app.qa.connect.trimble.com/tc/api/2.0`,
  maxCommentLength: MAX_COMMENT_LENGTH,
  maxAttachmentSize: MAX_ATTACHMENT_SIZE_MB * BYTES_PER_MEGABYTE,
  allowedAttachmentTypes: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  enableViewpoints: true,
  enableAttachments: true,
  commentsPerPage: DEFAULT_COMMENTS_PER_PAGE,
} as const;
